<button class="hamburger-floating" [class.visible]="isMobile()" (click)="toggleMobileMenu()" aria-label="Menú">
  <i class="bi" [class.bi-list]="!isMobileMenuOpen()" [class.bi-x]="isMobileMenuOpen()"></i>
</button>

<div class="menu-overlay" [class.visible]="isMobileMenuOpen()" (click)="closeMobileMenu()"></div>

<nav class="sidenav" 
     [class.expanded]="isExpanded() || isMobileMenuOpen()"
     [class.mobile-open]="isMobileMenuOpen()"
     (mouseenter)="!isMobile() && isExpanded.set(true)" 
     (mouseleave)="!isMobile() && isExpanded.set(false)">

  <div class="sidenav-toolbar">
    <div class="brand">
      <img src="/Logo_blanco.png" alt="Logo" class="sidebar-logo" width="40" height="24" />
      <span class="title">Odin Komunica</span>
    </div>
  </div>

  <div class="menu-container" (click)="isMobile() && closeMobileMenu()">
    @for (item of menuItems; track item.label) {
      @if (hasSubmenu(item)) {
        <div class="submenu-parent" [class.active]="isSubmenuExpanded(item.label)" (click)="toggleSubmenu(item.label)">
          <i [class]="getIcon(item.icon)" class="icon"></i>
          <span class="label">{{ item.label }}</span>
          <i class="bi bi-chevron-down submenu-arrow" [class.rotated]="isSubmenuExpanded(item.label)"></i>
        </div>
        @if (isSubmenuExpanded(item.label) && (isExpanded() || isMobileMenuOpen() || isMobile())) {
          <div class="submenu">
            @for (subitem of item.submenu; track subitem.route) {
              <a [routerLink]="subitem.route" routerLinkActive="active" class="submenu-item">
                <i [class]="getIcon(subitem.icon)" class="icon"></i>
                <span class="label">{{ subitem.label }}</span>
              </a>
            }
          </div>
        }
      } @else {
        <a [routerLink]="item.route" routerLinkActive="active" class="menu-item">
          <i [class]="getIcon(item.icon)" class="icon"></i>
          <span class="label">{{ item.label }}</span>
        </a>
      }
    }
  </div>
</nav>